import { render, staticRenderFns } from "./PqtMain.vue?vue&type=template&id=6e00fa24"
import script from "./PqtMain.vue?vue&type=script&lang=ts"
export * from "./PqtMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports